export default __webpack_public_path__ + "static/media/visits.652100c5.svg";